import { render, staticRenderFns } from "./point-cards.vue?vue&type=template&id=16928940&scoped=true"
import script from "./point-cards.vue?vue&type=script&lang=js"
export * from "./point-cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16928940",
  null
  
)

export default component.exports